// extracted by mini-css-extract-plugin
export default {"root":"select-module--root--aKdMi","native":"select-module--native--TCS5C","option":"select-module--option--vYv_p","flag":"select-module--flag--nfW9p"};